module.exports = __webpack_public_path__ + "static/media/frontend.615a5bea.png";